/* eslint-disable no-shadow, @typescript-eslint/no-explicit-any */
import { CountryCode } from './country';

export const currencyMap: any = {
  [CountryCode.MY]: 'RM',
  [CountryCode.HK]: 'HKD',
  [CountryCode.PH]: 'PHP',
  [CountryCode.ID]: 'RP',
  [CountryCode.SG]: 'SGD',
};
